// buildKeepRiseConfig.js
// Matches logic from AdvancedOrderPopup.handleFinalDone() KEEP_RISE branch. :contentReference[oaicite:5]{index=5}

function buildNonPreopenBase({
                                 side,
                                 executionMode,
                                 singleLargestOrderValue,
                                 totalDurationValue,
                                 totalDurationUnit,
                             }) {
    const execMode = (executionMode === "RELAXED" || executionMode === "AGGRESSIVE")
        ? executionMode
        : "AGGRESSIVE";

    if (execMode === "RELAXED" && (totalDurationValue === "" || Number(totalDurationValue) <= 0)) {
        return { error: "Total execution duration must be > 0 for RELAXED execution mode." };
    }

    const slvParsed = parseFloat(singleLargestOrderValue);
    if (!slvParsed || Number.isNaN(slvParsed) || slvParsed <= 0) {
        return { error: "Single largest order value (₹) must be > 0." };
    }

    let th = null;
    if (totalDurationValue !== "") {
        const raw = parseFloat(totalDurationValue);
        if (Number.isNaN(raw) || raw <= 0) {
            return {
                error:
                    execMode === "RELAXED"
                        ? "Total execution duration must be > 0 for RELAXED execution mode."
                        : "Total execution duration must be > 0 if specified.",
            };
        }

        switch (totalDurationUnit) {
            case "MINUTES":
                th = raw / 60.0;
                break;
            case "DAYS":
                th = raw * 24.0;
                break;
            case "HOURS":
            default:
                th = raw;
                break;
        }
    }

    return {
        base: {
            side,
            executionMode: execMode,
            totalDurationHours: th,
            singleLargestOrderValue: slvParsed,
            zerodhaUserId: null, // KEEP_RISE does not use selected user in your existing code path
        },
    };
}

export function buildKeepRiseConfig({
                                        side,

                                        keepSymbols,
                                        keepPercentRise,
                                        incQtyAbs,
                                        incAmountAbs,
                                        incQtyPct,
                                        incAmountPct,

                                        executionMode,
                                        singleLargestOrderValue,
                                        totalDurationValue,
                                        totalDurationUnit,
                                    }) {
    const baseRes = buildNonPreopenBase({
        side,
        executionMode,
        singleLargestOrderValue,
        totalDurationValue,
        totalDurationUnit,
    });
    if (baseRes.error) return { error: baseRes.error };

    const symbolsRaw = (keepSymbols || "").trim();
    if (!symbolsRaw) {
        return { error: "Please enter at least one symbol (comma separated if multiple)." };
    }

    const pct = parseFloat(keepPercentRise);
    if (!pct || pct <= 0 || Number.isNaN(pct)) {
        return { error: "Percent rise must be > 0." };
    }

    const qtyAbsNum = parseFloat(incQtyAbs);
    const amtAbsNum = parseFloat(incAmountAbs);
    const qtyPctNum = parseFloat(incQtyPct);
    const amtPctNum = parseFloat(incAmountPct);

    const activeTypes = [];
    if (!Number.isNaN(qtyAbsNum) && qtyAbsNum > 0) activeTypes.push("ABS_QTY");
    if (!Number.isNaN(amtAbsNum) && amtAbsNum > 0) activeTypes.push("ABS_AMOUNT");
    if (!Number.isNaN(qtyPctNum) && qtyPctNum > 0) activeTypes.push("PCT_QTY");
    if (!Number.isNaN(amtPctNum) && amtPctNum > 0) activeTypes.push("PCT_AMOUNT");

    if (activeTypes.length === 0) {
        return { error: "Please specify exactly one of incremental quantity/amount/quantity%/amount%." };
    }
    if (activeTypes.length > 1) {
        return { error: "Only one of the four incremental fields can be specified." };
    }

    const incType = activeTypes[0];
    let incValue;
    switch (incType) {
        case "ABS_QTY":
            incValue = qtyAbsNum;
            break;
        case "ABS_AMOUNT":
            incValue = amtAbsNum;
            break;
        case "PCT_QTY":
            incValue = qtyPctNum;
            break;
        case "PCT_AMOUNT":
            incValue = amtPctNum;
            break;
        default:
            return { error: "Unexpected incremental type." };
    }

    return {
        config: {
            ...baseRes.base,
            mode: "KEEP_RISE",
            symbols: symbolsRaw,
            percentRiseFromLastBuy: pct,
            incrementalType: incType,
            incrementalValue: incValue,
        },
        // KEEP_RISE: you intentionally kept popup open in old logic :contentReference[oaicite:6]{index=6}
        shouldAutoClose: false,
    };
}
